// src/components/pwa/steps/common/accountData.js
// Centralized mock data for both financial (personal) and commercial (business) accounts.

import React from 'react';
import { FaEuroSign, FaDollarSign, FaBitcoin, FaEthereum } from 'react-icons/fa';
import { SiTether } from 'react-icons/si';
import styled from 'styled-components';

const CurrencySymbol = styled.span`
    font-size: 20px;
    font-weight: bold;
    color: #1f2937;
`;

// --- Transfer screen accounts ---
const TRANSFER_ACCOUNTS = {
    cross_border: [
        { id: 1, name: 'USD Account', number: 'US09...6543', balance: 8355.75, currency: 'USD' },
        { id: 2, name: 'EUR Account', number: 'ES12...5678', balance: 15250.50, currency: 'EUR' },
    ],
    business: [
        { id: 1, name: 'EUR Account', number: 'ES12...5678', balance: 250730.00, currency: 'EUR' },
        { id: 2, name: 'USD Account', number: 'US09...6543', balance: 120500.50, currency: 'USD' },
    ],
};

// --- Transfer recipients ---
const TRANSFER_RECIPIENTS = {
    cross_border: [
        { id: 101, name: 'John Rose - External Bank', number: 'EX99...0001', currency: 'USD' },
        { id: 102, name: 'Jane Smith - Spouse', number: 'US09...5555', currency: 'USD' },
        { id: 103, name: 'Acme Corp - Rent Payment', number: 'ES12...1111', currency: 'EUR' },
    ],
    business: [
        { id: 101, name: 'Supplier A', number: 'EX99...0001', currency: 'USD' },
        { id: 102, name: 'Supplier B', number: 'ES12...1111', currency: 'EUR' },
    ],
};

// --- Account Manager screen accounts ---
const MANAGER_ACCOUNTS = {
    cross_border: [
        { id: 1, name: 'USD Account', accountNumber: 'US09 8765 4321 0987 6543', currency: 'USD', totalBalance: '12,450.00', availableBalance: '12,400.00' },
        { id: 2, name: 'EUR Account', accountNumber: 'ES12 3456 7890 1234 5678', currency: 'EUR', totalBalance: '8,350.50', availableBalance: '8,300.00' },
    ],
    business: [
        { id: 1, name: 'USD Account', accountNumber: 'US09 8765 4321 0987 6543', currency: 'USD', totalBalance: '150,500.00', availableBalance: '148,000.00' },
        { id: 2, name: 'EUR Account', accountNumber: 'ES12 3456 7890 1234 5678', currency: 'EUR', totalBalance: '95,200.50', availableBalance: '94,000.00' },
    ],
};

// --- Profile screen data ---
const PROFILE_DATA = {
    cross_border: {
        greeting: 'Hello, Apex Financial!',
        totalBalance: '$8,355.75',
        fiatAccounts: [
            { id: 2, label: 'USD Account', detail: 'US09...6543', balance: '$8,355.75', icon: <FaDollarSign size={22} color="#1f2937" /> },
            { id: 1, label: 'EUR Account', detail: 'ES12...5678', balance: '€15,250.50', icon: <FaEuroSign size={22} color="#1f2937" /> },
        ],
        cryptoAccounts: [
            { id: 5, label: 'Crypto Holdings', detail: 'Unified Balance', balance: '$18,750.00', icon: <FaBitcoin size={22} color="#1f2937" /> },
        ],
    },
    business: {
        greeting: 'Hello, Tech Corp!',
        totalBalance: '$120,500.50',
        fiatAccounts: [
            { id: 2, label: 'Dollar', detail: 'US09...WXYZ', balance: '$120,500.50', icon: <FaDollarSign size={22} color="#1f2937" /> },
            { id: 1, label: 'Euro', detail: 'ES12...ABCD', balance: '€250,730.00', icon: <FaEuroSign size={22} color="#1f2937" /> },
        ],
        cryptoAccounts: [
            { id: 5, label: 'Treasury', detail: 'Unified Balance', balance: '$55,000.00', icon: <FaBitcoin size={22} color="#1f2937" /> },
        ],
    },
};

// --- Crypto holdings ---
const CRYPTO_ASSETS = {
    cross_border: [
        { id: 'BTC', name: 'Bitcoin', balance: '0.5 BTC', value: '$34,270.00', icon: <span style={{ color: '#000000', fontWeight: 'bold', fontSize: '18px' }}>₿</span> },
        { id: 'ETH', name: 'Ethereum', balance: '2.5 ETH', value: '$8,750.00', icon: <FaEthereum size={24} color="#000000" /> },
        { id: 'USDT', name: 'Tether', balance: '10,000 USDT', value: '$10,000.00', icon: <SiTether size={24} color="#000000" /> },
    ],
    business: [
        { id: 'BTC', name: 'Bitcoin', balance: '1.5 BTC', value: '$92,250.00', icon: <FaBitcoin size={24} color="#000000" /> },
        { id: 'ETH', name: 'Ethereum', balance: '10.0 ETH', value: '$34,000.00', icon: <FaEthereum size={24} color="#000000" /> },
    ],
};

// --- Crypto trade user data ---
const CRYPTO_USER = {
    cross_border: {
        balanceUSD: 8355.75,
        portfolio: { BTC: 0.5, ETH: 2.5, USDT: 10000 },
    },
    business: {
        balanceUSD: 385125.34,
        portfolio: { BTC: 1.5, ETH: 10 },
    },
};

export {
    TRANSFER_ACCOUNTS,
    TRANSFER_RECIPIENTS,
    MANAGER_ACCOUNTS,
    PROFILE_DATA,
    CRYPTO_ASSETS,
    CRYPTO_USER,
    CurrencySymbol,
};
